<template>
  <el-container>
    <el-header>
      <div style="background: #409EFF;height: 50px;width: 100%">
        <div style="float: left;width: 50%">
          <img src="../../static/imgs/img_start_4.png" height="40px" width="120px"
               style="line-height: 40px;float: left;margin-left:20px;margin-top: 5px"
               onClick="javascript :history.back(-1)">
        </div>
        <div style="float: right;width: 50%;margin-top: 15px;">
          <el-row :gutter="20" style="float: right;font-size: 16px;color: #EBEEF5;font-weight: 400;padding-right: 20px">
            <el-col :span="30">
              <!-- <el-dropdown style="font-size: 16px;color: #EBEEF5;font-weight: 400;"
                            trigger="click">
                   <span class="el-dropdown-link" id="change_env">环境切换<i
                     class="el-icon-arrow-down el-icon&#45;&#45;right"></i></span>
                 <el-dropdown-menu slot="dropdown">
                   <el-dropdown-item v-for="item in options_env" :key="item" :value="item.key"
                                     @click.native="changeServer(item.key)">{{item.key}}
                   </el-dropdown-item>
                 </el-dropdown-menu>
               </el-dropdown>-->
            </el-col>
          </el-row>
        </div>
      </div>
    </el-header>
    <el-main>
      <el-row>
        <el-col :span="24"><img src="../../static/imgs/ic_launcher.png" height="80" width="80"
                                style="border-radius: 15px"/></el-col>
      </el-row>
      <div style="margin-top: 30px">
        <div>
          <span><img src="../../static/imgs/ios_icon.png" height="17" width="17" id="info_os"/></span>
          <span style="margin-left: 10px" id="info_app_name">{{currentInfo.app_display_name}}</span>
          <span id="info_app_lable"
                style="border-radius: 3px;background: #409EFF;font-size: 9px;color: #EBEEF5;width: 44px;height: 18px;text-align: center;display:-moz-inline-box; display:inline-block;margin-left: 10px">企业版</span>
        </div>
      </div>
      <center>
        <el-row>
          <el-col :span="24" style="font-size: 12px;color: #909399;margin-top: 10px">
            <span id="info_app_info_one">
              <span>版本: {{currentInfo.app_version}} (build {{currentInfo.app_build_num}}) &emsp;大小：{{currentInfo.app_size}} &emsp;来源：{{currentInfo.source}}</span>
              <a v-if="currentInfo.symbol_url" :href="currentInfo.symbol_url">{{currentInfo.symbol_url}}</a>
            </span>
          </el-col>
          <el-col :span="24" style="font-size: 12px;color: #909399;margin-top: 10px">
            <span id="info_app_info_two">
              更新时间：{{currentInfo.app_upload_time}}&emsp;环境：{{currentInfo.app_package_env}}&emsp;分支：{{currentInfo.app_package_branch}}&emsp;APK-MD5：{{currentInfo.md5}}
            </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <template>
              <canvas id="qr_canvas" style="width: 100px;height: 100px"></canvas>
            </template>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-button type="primary" round style="width: 120px" id="info_download">
              <a :href="btnHref" style="text-decoration: none; color: #fff;">{{ canDownload ? '点击安装' : '链接地址不存在' }}</a>
            </el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="font-size: 12px;color: #909399; margin-top: 20px">或者用手机扫描二维码安装</el-col>
        </el-row>
        <el-table :data="module_info" style="margin-top: 30px;width: 400px">
          <el-table-column prop="module_name" label="组件信息" align="center"/>
          <el-table-column prop="module_version" label="版本号" align="center"/>
        </el-table>
        <el-row>
          <el-col :xs="5" :sm="5" :md="5" :lg="15" :xl="15" style="margin-top: 20px;color: #909399;font-size: 15px">
            历史版本
          </el-col>
        </el-row>
        <el-table :header-cell-style="{background:'#E4E7ED'}" :data="historyData" style="margin-top: 10px;width: 600px"
                  :row-class-name="tableRowClassName" @row-click="handleClick">
          <el-table-column prop="version" label="版本号 - Build号" align="center"/>
          <el-table-column prop="env" label="环境" align="center"/>
          <el-table-column prop="branch" label="分支" align="center"/>
          <el-table-column prop="upload_time" label="时间" align="center"/>
        </el-table>
      </center>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        layout=" prev, pager, next"
        style="margin-top: 20px">
      </el-pagination>
    </el-main>
  </el-container>
</template>
<style>
  .el-header {
    padding: 0px;
    margin: 0px;
  }

  .el-footer {
    padding: 0px;
    margin: 0px;
  }

  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>
<script>
  import QRCode from 'qrcode'
  export default {
    data () {
      return {
        pageNum: 1,
        currentPage: this.pageNum,
        response: [],
        historyData: [],
        module_info: [],
        submitForm: {},
        packageId: '',
        appId: '',
        buildNum: '',
        // 本版本应用信息详情
        currentInfo: {},
        btnHref: 'javascript: void(0)', // 安装按钮的跳转链接
        canDownload: true // 能否下载
      }
    },
    mounted: function () {
      this.packageId = this.$route.query.package_id
      this.buildNum = this.$route.query.build_num
      this.appId = this.$route.query.app_id
      if (this.isNotEmpty(this.$store.state.token)) {
        this.getData()
      } else if (this.isNotEmpty(localStorage.getItem('A376024058_token'))) {
        // 复制详情url传播的时候 取一下本地缓存做个校验
        this.gettickt()
      } else {
        window.location.href = 'https://sso.saash.vdyoo.com/portal/login/A376024058'
      }
    },
    components: {
      QRCode: QRCode
    },
    methods: {
      getData () {
        this.appInfo(this.packageId)
        this.appHistory(this.appId, this.pageNum, this.buildNum, this.packageId)
        this.checkEvn(this.appId)
      },
      gettickt () {
        this.axios({
          method: 'get',
          url: 'v1/app/ticket',
          params: {
            appId: 'A376024058',
            appKey: '4LFh03FPbf6omXsX'
          }
        }).then((res) => {
          var ticket = res.data.data.ticket
          this.$store.commit('addToken', localStorage.getItem('A376024058_token'))
          this.getuserinfo(ticket, localStorage.getItem('A376024058_token'))
        }).catch((error) => {
          console.log(error)
        })
      },
      gettickt2 () {
        this.axios({
          method: 'get',
          url: 'v1/app/ticket',
          params: {
            appId: '1563268962',
            appKey: 'dKsbqPG7LhfK4Tr6'
          }
        }).then((res) => {
          var ticket = res.data.data.ticket
          this.$store.commit('addToken', localStorage.getItem('A376024058_token'))
          this.getuserinfo(ticket, localStorage.getItem('A376024058_token'))
        }).catch((error) => {
          console.log(error)
        })
      },
      getuserinfo (ticket, token) {
        this.axios({
          method: 'get',
          url: 'v1/app/sso/verify',
          params: {
            token: token,
            ticket: ticket
          }
        }).then((res) => {
          if (res.data.data.errcode === 0 || res.data.data.errcode === '0') {
            this.getData()
          } else {
            this.$store.commit('addToken', '')
            window.location.href = 'https://sso.saash.vdyoo.com/portal/login/A376024058'
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      /** changeServer (item) {
        document.getElementById('change_env').innerHTML = item + '<i class="el-icon-arrow-down el-icon--right">'
        this.appInfo(this.appId)
      },**/
      isNotEmpty (text) {
        if (text !== null && text !== '' && text !== 'null') {
          return true
        } else {
          return false
        }
      },
      isPC () {
        if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile)/i))) {
          console.log('mobile')
          return false
        } else {
          console.log('pc')
          return true
        }
      },
      changeOs (os) {
        var imgOs = document.getElementById('info_os')
        var company = document.getElementById('info_app_lable')
        if (os === 'ios') {
          imgOs.setAttribute('src', '../../static/imgs/ios_icon.png')
        } else {
          imgOs.setAttribute('src', '../../static/imgs/android_icon.png')
          company.style.display = 'none'
        }
      },
      loadQrcode (url, os) {
        if (url !== '') {
          var canvas = document.getElementById('qr_canvas')
          var reslurUrl
          if (os === 'ios') {
            reslurUrl = 'itms-services://?action=download-manifest&url=' + url
            console.log('ios=' + reslurUrl)
          } else {
            reslurUrl = url
            console.log('android=' + reslurUrl)
          }
          QRCode.toCanvas(canvas, reslurUrl, error => {
            if (error) console.error(error)
            console.log('success!')
          })
        }
      },
      appInfo (id) {
        this.axios({
          method: 'post',
          url: 'v1/app/info',
          data: {
            packageId: id
          }
        })
        // this.axios({
        //   method: 'get',
        //   url: './static/info.json'
        // })
        .then((res) => {
          window.scrollTo(0, 0)
          var response = res.data.data
          this.currentInfo = response
          console.log(this.currentInfo)
          this.module_info = response.app_module_info

          if (response.app_platform === 'android' || this.isPC()) {
            if (response.app_platform === 'ios') {
              this.loadQrcode(response.plist_url, response.app_platform)
            } else {
              this.loadQrcode(response.app_url, response.app_platform)
            }
            this.btnHref = response.app_url ? response.app_url : 'javascript: void(0)'
            this.canDownload = response.app_url ? 1 : 0
          } else {
            this.loadQrcode(response.plist_url, response.app_platform)
            this.btnHref = response.plist_url ? 'itms-services://?action=download-manifest&url=' + response.plist_url : 'javascript: void(0)'
            this.canDownload = response.plist_url ? 1 : 0
          }
          // if (response.app_platform === 'ios') {
          //   this.loadQrcode(response.plist_url, response.app_platform)
          //   if (this.isPC()) {
          //     this.btnDownLoad(response.app_url, response.app_platform)
          //     this.btnHref = response.app_url;
          //   } else {
          //     this.btnDownLoad(response.plist_url, response.app_platform)
          //     this.btnHref = response.plist_url;
          //   }
          // } else {
          //   this.loadQrcode(response.app_url, response.app_platform)
          //   this.btnDownLoad(response.app_url, response.app_platform)
          //   this.btnHref = response.app_url;
          // }
          this.changeOs(response.app_platform)
        }).catch((error) => {
          console.log(error)
        })
      },
      appHistory (appid, page, num, pack) {
        this.axios({
          method: 'post',
          url: 'v1/app/history',
          data: {
            appId: appid,
            page: page + '',
            buildNum: num,
            packageId: pack
          }
        }).then((res) => {
          var response = res.data.data.data
          response.forEach(function (value, i) {
            value.version = value.version + ' - ' + value.build_num
          })
          this.historyData = response
        }).catch((error) => {
          console.log(error)
        })
      },
      checkEvn (appid) {
        this.axios({
          method: 'post',
          url: 'v1/app/env',
          data: {
            appId: appid
          }
        }).then((res) => {
          var response = res.data.data
          this.options_env = response
        }).catch((error) => {
          console.log(error)
        })
      },
      tableRowClassName ({row, rowIndex}) {
        if (rowIndex % 4 === 0) {
          return ''
        } else if (rowIndex % 4 === 1) {
          return 'success-row'
        } else if (rowIndex % 4 === 2) {
          return ''
        } else if (rowIndex % 4 === 3) {
          return 'warning-row'
        }
        return ''
      },
      handleCurrentChange (val) {
        this.appHistory(this.appId, val, this.buildNum, this.packageId)
      },
      // 无用
      // btnDownLoad (url, os) {
      //   var dow = document.getElementById('info_download')
      //   dow.onclick = () => {
      //     console.log(this.isPC())
      //     if (url === '' || url === null || url === 'null') {
      //       this.windowAlert()
      //       return
      //     }
      //     if (this.isPC() || os === 'android') {
      //       window.open(url)
      //     } else {
      //       window.open('itms-services://?action=download-manifest&url=' + url)
      //     }
      //   }
      // },
      handleClick (row) {
        this.appInfo(row.package_id)
        this.appHistory(row.app_id, this.pageNum, row.build_num, row.package_id)
        this.checkEvn(row.app_id)
        this.packageId = row.package_id
        this.buildNum = row.build_num
        this.appId = row.app_id
        console.log(this.appId)
        console.log(this.buildNum)
        console.log(this.packageId)
      },
      windowAlert () {
        this.$notify.error({
          title: '错误',
          message: '下载链接地址不存在'
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/info.vue